import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import AppLayout from '../../../../../layout/components/AppLayout';
import grievanceServices from '../grievanceServices';
import { useAppData } from '../../../../../context/AppDataContext';
import GrievanceRemarkForm from '../components/GrievanceRemarkForm';
import GrievanceRemarkList from '../components/GrievanceRemarkList';
import GrievanceStatusUpdate from '../components/GrievanceStatusUpdate';


const LabelValue = ({label,value}) =>{
    return(
        <div className='row'>
            <div className='col-md-6 fw-bold'>{label}</div>
            <div className='col-md-6 fw-bold'>{value}</div>
        </div>
    )
}


function GrievanceDetailsPage() {
    const {id} = useParams();
    const {getMasterLabel} = useAppData();
    const [grievanceDetails,setGrievanceDetails] = useState(null);


    const [refreshKey, setRefreshKey] = useState(0);

    const callBack = () => {
        // Incrementing this will change the prop passed to the list
        setRefreshKey(prev => prev + 1);
    };

    const getGrievanceDetails = () =>{
        grievanceServices.getById(id).then(res=>{
            setGrievanceDetails(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    useEffect(()=>{
        getGrievanceDetails();
    },[id])

    return (
        grievanceDetails &&
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-4'>
                        <div className='card'>
                            <div className='card-body'>
                                <LabelValue label="Customer Name" value={grievanceDetails.customerName} />
                                <LabelValue label="Customer Phone" value={grievanceDetails.customerPhone} />
                                <LabelValue label="Grievance Type" value={getMasterLabel('grievance-type',grievanceDetails.grievanceType)} />
                                <LabelValue label="UID" value={grievanceDetails.uid} />
                                <div className='row mt-3'>
                                    <hr/>
                                    <div className='col-md-12 fw-bold'>Complain Details</div>
                                    <div className='col-md-12'>{grievanceDetails.textMessage}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <GrievanceRemarkForm grievanceId={id} callBack={callBack} />
                        <GrievanceRemarkList grievanceId={id} refreshTrigger={refreshKey} />
                    </div>
                    <div className='col-md-2'>
                        <GrievanceStatusUpdate grievanceDetails={grievanceDetails} callBack={getGrievanceDetails} />
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default GrievanceDetailsPage